export default __webpack_public_path__ + "static/media/grey_dolphin_icon_against.ccef2765.svg";